import { ParametroRutas, GetResponseBody, GetHeaderRequest, GetHeaderRequestFormData  } from './RutasConfig';

export const Get_Description_Report = async (pToken, pReport) => {
    const result = await fetch(ParametroRutas.Get_Description_Report + "?pReport=" + pReport, {
        method: 'GET',
        headers: GetHeaderRequestFormData(pToken)
    });
    return await GetResponseBody(result);
};

export const Obtener_CallCenter_Empresa_Request = async (pToken, EmpresaId) => {
    const result = await fetch(ParametroRutas.Obtener_CallCenter_Empresa, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(EmpresaId)
    });
    return await GetResponseBody(result);
};

export const Obtener_Empresas_Request = async (pToken) => {
    const result = await fetch(ParametroRutas.Obtener_Empresas, {
        method: 'GET',
        headers: GetHeaderRequest(pToken)
    });
    return await GetResponseBody(result);
};

/**************parametros Sucursal****************/
export const ObtieneParametroSucursal = async (pToken, EmpresaId, SucursalId, Nombre) => {
    const data = { EmpresaId, SucursalId, Nombre };
    const result = await fetch(ParametroRutas.ObtieneParametroSucursal, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};

export const Obtener_Simbolo_Moneda_Request = async (pToken, EmpresaId) => {
    const result = await fetch(ParametroRutas.Obtener_Simbolo_Moneda, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(EmpresaId)
    });
    return await GetResponseBody(result);
};

/*Parametros Seguridad*/
export const Obtener_Estado_Active_Directory_Request = async () => {
    const result = await fetch(ParametroRutas.Obtener_Estado_Active_Directory);
    return await result.json();
};